import React, { Component } from 'react';
import axios from "axios";
import {appConfig} from "./../../tools/AppConfig";
import Card from './../iframes/components/card/card';
import Waiting from './../waiting';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Select from 'react-validation/build/select';
import Button from 'react-validation/build/button';
import './../../custom.css';
import './../../pages/invoice.css';
import visaImg from './../../../statics/img/visa.svg';
import creditImg from './../../../statics/img/credit.svg';
import AAIBLogoImg from './../../../statics/img/AAIB-logo.png';
import acceptBlueImg from './../../../statics/img/accept_blue.png';
import validator from 'validator';
const required = (value) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> This field is required.</div>;
  }
};
const CreditCard = (value) => {
    let regex = new RegExp("^[0-9]{16}$");
    if (!regex.test(value)) {
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter a valid card number.</div>;
    };
}
const Cvv = (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length < 3 || value.toString().trim().length > 4 ){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid CVV.</div>;
    }
};
const FullName = (value) => {
    var patt = new RegExp("[a-zA-Z]+ [a-zA-Z]+");
    if(!patt.test(value)){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid card holder name.</div>;
    }
};

class card extends Component {
      constructor(props) {
        super(props);
        this.state = {
            waiting: false,
            userData: props.userData,
            deliveryNeed: props.deliveryNeed,
            deliveryData: props.deliveryData,
            cardNumber: '',
            cardHolderName: '',
            expiryMonth: '',
            expiryYear: '',
            cvv: '',
        };
        this.getFirstName = this.getFirstName.bind(this);
        this.getLastName = this.getLastName.bind(this);
      }
  
  getFirstName(fullName) {
    var namesArr = fullName.split(" ");
    return namesArr[0]
  }
  getLastName(fullName) {
    var namesArr = fullName.split(" ");
    return namesArr[namesArr.length - 1];
  }
  handleSubmit = (card_data) => {
    //start waiting
    this.setState({waiting: true},() => {
        //disable payment method options
        this.props.disableAllPaymentMethods();
        //post req
        let url;
        if(this.props.sourcePage ==='invoice'){
            url = appConfig.getServerUrl() + '/invoice2/'+ this.state.userData.token;
        }else if(this.props.sourcePage ==='product'){
            url = appConfig.getServerUrl() + '/product2/'+ this.state.userData.token;
        }
        let paymentDict;
        if(this.props.sourcePage ==='invoice'){
            paymentDict = {
                "source": {
                    "identifier": card_data.cardNumber,
                    "sourceholder_name": card_data.name,
                    "expiry_month": card_data.expiry_mm,
                    "expiry_year": card_data.expiry_yy,
                    "cvn": card_data.cvc,
                    "subtype": "CARD",
                    "save_card": card_data.save_card
                }, "shipping_data": {
                    'apartment': "",
                    'email': this.state.userData.order_email,
                    'floor': "",
                    'first_name': this.getFirstName(this.state.userData.order_full_name),
                    'street': "",
                    'building': "",
                    'phone_number': this.state.userData.order_phone,
                    'postal_code': "",
                    'city': "",
                    'country': "",
                    'last_name': this.getLastName(this.state.userData.order_full_name),
                    'state': "",
                    'extra_description': ""
                },
                "token": this.state.userData.token,
                "integration_id": this.state.userData.integration_ids.VPC,
                "save_card": card_data.save_card
            };
            if(this.state.deliveryNeed){
                if(this.props.deliveryData.name){
                    paymentDict.shipping_data.first_name = this.getFirstName(this.props.deliveryData.name);
                    paymentDict.shipping_data.last_name = this.getLastName(this.props.deliveryData.name);
                }
                if(this.props.deliveryData.phone){
                    paymentDict.shipping_data.phone_number = this.props.deliveryData.phone;
                }
                if(this.props.deliveryData.email){
                    paymentDict.shipping_data.email = this.props.deliveryData.email;
                }
                paymentDict.shipping_data.country = this.state.deliveryData.country;
                paymentDict.shipping_data.state = this.state.deliveryData.state;
                paymentDict.shipping_data.city = this.state.deliveryData.city;
                paymentDict.shipping_data.building = this.state.deliveryData.building;
                paymentDict.shipping_data.street = this.state.deliveryData.street;
                paymentDict.shipping_data.floor = this.state.deliveryData.floor;
                paymentDict.shipping_data.apartment = this.state.deliveryData.apartment;
                paymentDict.shipping_data.postal_code = this.state.deliveryData.postal_code;
            }
            if(this.state.deliveryData && this.state.deliveryData.national_id){
                paymentDict.shipping_data.extra_description = this.state.deliveryData.national_id;
            }
        }else if(this.props.sourcePage ==='product'){
            paymentDict = {
                "order_data": {
                    "delivery_needed": this.state.deliveryNeed,
                    "amount_cents": this.state.userData.amount * this.props.quantity * 100,
                    "currency": this.state.userData.currency,
                    "shipping_data": {
                        "first_name": this.getFirstName(this.state.deliveryData.name),
                        "last_name": this.getLastName(this.state.deliveryData.name),
                        "phone_number": this.state.deliveryData.phone,
                        "email": this.state.deliveryData.email,
                        "street": 'NA',
                        "city": 'NA',
                        "country": 'NA',
                        "postal_code": 'NA',
                        "state": "NA",
                        'extra_description': ""
                    },
                    "items": [{
                        "name": this.state.userData.product.product_name,
                        "amount_cents": this.state.userData.amount * 100,
                        "quantity": this.props.quantity,
                    }]
                },
                "source": {
                    "identifier": card_data.cardNumber,
                    "sourceholder_name": card_data.name,
                    "expiry_month": card_data.expiry_mm,
                    "expiry_year": card_data.expiry_yy,
                    "cvn": card_data.cvc,
                    "subtype": "CARD",
                    "save_card": card_data.save_card
                },
                "token": this.state.userData.token,
                "integration_id": this.state.userData.integrations.VPC,
                "save_card": card_data.save_card
            };
            if(this.state.deliveryNeed){
                paymentDict.order_data.shipping_data.country = this.state.deliveryData.country;
                paymentDict.order_data.shipping_data.state = this.state.deliveryData.state;
                paymentDict.order_data.shipping_data.city = this.state.deliveryData.city;
                paymentDict.order_data.shipping_data.building = this.state.deliveryData.building;
                paymentDict.order_data.shipping_data.street = this.state.deliveryData.street;
                paymentDict.order_data.shipping_data.floor = this.state.deliveryData.floor;
                paymentDict.order_data.shipping_data.apartment = this.state.deliveryData.apartment;
                paymentDict.order_data.shipping_data.postal_code = this.state.deliveryData.postal_code;
            }
            if(this.state.deliveryData && this.state.deliveryData.national_id){
                paymentDict.order_data.shipping_data.extra_description = this.state.deliveryData.national_id;
            }
        }


        let jsonPaymentDict = JSON.stringify(paymentDict);
        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        axios.post(url, jsonPaymentDict, config)
        .then((resp) => {
            //enable payment methods
            this.props.enableAllPaymentMethods();
            //show result
            if(resp.data.success === true){
                if (resp.data.url) {
                    window.location.href = resp.data.url;
                }else {
                    //stop waiting
                    this.setState({waiting: false});
                    if(this.state.deliveryNeed){
                        //succes without url and delivery
                        this.props.setReqComplete({head: 'Transaction successful', body:'The Courier will be in touch to determine the exact collection time.'});
                    }else{
                        //succes without url and not delivery
                        this.props.setReqComplete({head: 'Transaction successful', body:'Thank you for using the online payment service.'});
                    }
                }
            }else{
                //succes = false
                this.props.setReqComplete({head: 'Transaction declined', body:'Please try again later. If this problem persists, please contact your service provider.'});
            }
        })
        .catch((err) => {
            //stop waiting
            this.setState({waiting: false});
            //enable payment methods
            this.props.enableAllPaymentMethods();
            if(err.response.data && Array.isArray(err.response.data)  && err.response.data[0]){
                this.props.setReqComplete({head: 'Transaction declined', body: err.response.data[0]});
            }else{
                this.props.setReqComplete({head: 'Transaction declined', body:'Please try again later. If this problem persists, please contact your service provider.'});
            }
        });
    });
  }

  render() {
    return (
        <div className="cardNew">
            <h3>Add your card information</h3>
            <div className="text-center">
                <Card 
                    can_save_card={this.state.userData && this.state.userData.can_save_card} 
                    card_submit={this.handleSubmit}
                    waiting={this.state.waiting}
                />
            </div>
        </div>
    );
  }
}

export default card;
